module.exports = __webpack_public_path__ + "static/media/11.c2b1c2b9.jpg";